import { useEffect } from 'react';
import type { RefObject } from 'react';

export function useAutoFocus<T extends HTMLElement>(ref: RefObject<T | null>, enabled: boolean = true): void {
  useEffect(() => {
    if (enabled) {
      ref.current?.focus();
    }
  }, [enabled, ref]);
}
